import React from "react";

const defaultSteelProductionData = [
  {
    process: "Raw steel production: basic oxygen furnace processes",
    value: "",
  },
  {
    process: "Raw steel production: electric arc furnace processes",
    value: "",
  },
  {
    process: "Raw steel production: basic oxygen furnace processes (%)",
    value: "",
  },
  {
    process: "Raw steel production: electric arc furnace processes (%)",
    value: "",
  },
];

const RawSteelProductionTable = ({
  steelProductionTable,
  setSteelProductionTable,
}) => {
  const safeSteelProductionTable = Array.isArray(steelProductionTable)
    ? steelProductionTable
    : defaultSteelProductionData;

  const handleInputChange = (rowIndex, value) => {
    const updatedData = [...safeSteelProductionTable];
    updatedData[rowIndex].value = value;
    setSteelProductionTable(updatedData);
  };

  return (
    <div>
      <p style={{ marginBottom: "10px", color: "#222" }}>
        Fill the table based on your entire operation.
      </p>
      <div
        style={{
          marginTop: "20px",
          border: "1px solid #000",
          borderRadius: "8px",
          overflow: "hidden",
          width: "100%",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr
              style={{
                backgroundColor: "#D3C9CE",
                color: "#000",
                fontWeight: "bold",
                textAlign: "left",
              }}
            >
              <th style={tableHeaderStyle}>Raw Steel Production</th>
              <th style={tableHeaderStyle}>(metric tons cast)</th>
            </tr>
          </thead>
          <tbody>
            {safeSteelProductionTable.map((row, index) => (
              <tr key={index}>
                <td
                  style={{
                    ...tableCellStyle,
                    backgroundColor: "#f5f5f5",
                    fontWeight: "bold",
                  }}
                >
                  {row.process}
                </td>
                <td style={tableCellStyle}>
                  <input
                    type="number"
                    value={row.value}
                    onChange={(e) => handleInputChange(index, e.target.value)}
                    style={inputFieldStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputFieldStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

export default RawSteelProductionTable;
